export function AiAgentFieldMentionIcon({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M4 3.33301C2.89543 3.33301 2 4.22844 2 5.33301V10.6663C2 11.7709 2.89543 12.6663 4 12.6663H6.66667C7.03486 12.6663 7.33333 12.3679 7.33333 11.9997C7.33333 11.6315 7.03486 11.333 6.66667 11.333H4C3.63181 11.333 3.33333 11.0345 3.33333 10.6663V5.33301C3.33333 4.96482 3.63181 4.66634 4 4.66634H12C12.3682 4.66634 12.6667 4.96482 12.6667 5.33301V7.33301C12.6667 7.7012 12.9651 7.99967 13.3333 7.99967C13.7015 7.99967 14 7.7012 14 7.33301V5.33301C14 4.22844 13.1046 3.33301 12 3.33301H4Z"
        fill="#737373"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.63148 6.07006C7.37482 5.94173 7.06484 5.99203 6.86193 6.19494C6.65902 6.39784 6.60872 6.70782 6.73705 6.96448L9.40372 12.2978C9.49955 12.4895 9.68168 12.6234 9.89321 12.6577C10.1047 12.6921 10.3199 12.6226 10.4714 12.4711L11.3333 11.6091L12.1953 12.4711C12.4556 12.7314 12.8777 12.7314 13.1381 12.4711C13.3984 12.2107 13.3984 11.7886 13.1381 11.5283L12.2761 10.6663L13.1381 9.80441C13.2896 9.65288 13.3591 9.43775 13.3247 9.22622C13.2904 9.01469 13.1565 8.83256 12.9648 8.73672L7.63148 6.07006ZM10.1826 10.8742L8.82405 8.15705L11.5412 9.51564L10.1826 10.8742Z"
        fill="#737373"
      />
    </svg>
  );
}
